/** A quiet amber line on the scenarios panel: a warning about what is on screen, or a refusal the reader dismisses. */

import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PanelNoteProps {
	children: ReactNode;
	role?: 'alert' | 'status';
	onDismiss?: () => void;
	className?: string;
}

export const PanelNote = ({ children, role, onDismiss, className }: PanelNoteProps) => (
	<div role={role} className={cn('flex shrink-0 items-start gap-2 text-xs leading-4 text-amber-700', className)}>
		<p className='min-w-0 flex-1'>{children}</p>
		{onDismiss && (
			<button
				type='button'
				onClick={onDismiss}
				aria-label='Dismiss'
				className='shrink-0 cursor-pointer rounded-sm text-amber-700 transition-colors hover:text-amber-900'
			>
				<X className='size-3.5' aria-hidden />
			</button>
		)}
	</div>
);
